import React from 'react'
import { Row, Col, Container } from 'react-grid-system';

import { bindActionCreators } from 'redux'
import { withRouter }         from 'react-router-dom'
import { connect }            from 'react-redux'

import './styles.scss'

import EncodingStatus      from '../../components/Encoding/Status/encoding-status'

class Encoding extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      access_control  : 'private',
      s3Acceleration  : false,
      selection : {
        size  : 0,
        cost  : 0,
        count : 0
      }
    }
  }

  componentWillReceiveProps(props) {
    this.setState({selection : props.selection})
  }

  render () {
    return (
      <Container className='encoding noselect' fluid>
       {/* <Row className='header-row'>
          <Col md={6} >
            <SelectionFilesCount total_files_count={this.state.selection.count}/>
          </Col>

          <Col md={6}>
            <SelectionFilesSize total_files_size={this.state.selection.size}/>
          </Col>
        </Row>

        <Row className='header-row'>
          <Col md={6} >
            <TextIndicator text={'Upload your source video file'}/>
          </Col>

          <Col md={6} >
            <TextIndicator text={'Encode existing video'}/>
          </Col>
        </Row>

        <Row className='content-row'>
          <Col md={6}>
            <LocalFilesSystem
              s3Acceleration={this.state.s3Acceleration}
              access_control={this.state.access_control}
              provider       = {'encoding'}/>
          </Col>

          <Col md={6}>
            <CloudFilesSystem title={'Files System'} state={'encoding'}/>
          </Col>
        </Row>
*/}
        <Row className='content-row'>
          <Col md={12}>
            <EncodingStatus/>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default withRouter(connect(({ auth:{user={}}, s3Direct:{selection={}} }) => {
  return {
    user,
    selection
  }
}, (dispatch) => bindActionCreators({}, dispatch))(Encoding))
